export class SessionStorageUtil {

    static set(key, value){

        window.sessionStorage.setItem(key, JSON.stringify(value));
    }

    static get(key){

        return JSON.parse(window.sessionStorage.getItem(key));
    }

    static delete(key){
        
        window.sessionStorage.removeItem(key);
    }

    static clear(){

        window.sessionStorage.clear();
    }

    static get KEY_NAMES () {

        return {
            CROPS: 'cropUuids',
            FIELDS: 'fieldUuids',
            CROP_SEASONS: 'cropSeasonUuids',
            TASKS: 'taskUuids',
            POIS: 'poiUuids',
            REDIRECT_ROUTE: 'redirect',
            GEO_FEATURES_DRAW_AB_LINE: 'draw_ab_line',
            GEO_FEATURES_EDIT_AB_LINE: 'edit_ab_line',
            GEO_FEATURES_ADD_FIELD_ENTRY: 'add_field_entry',
            GEO_FEATURES_EDIT_FIELD_ENTRY: 'edit_field_entry',
            GEO_FEATURES_ZONE_GENERATION: 'zone_generation',
            HF_CONTRACTOR_DETAILS: 'hf_contractor',
            WEED_PRESSURE_GROUP: 'weedPressureGroup'
        };
    }
}



// WEBPACK FOOTER //
// ./shared/utils/SessionStorageUtil.js